/* eslint-disable no-nested-ternary */
import React, { ReactElement } from 'react';

type ProgressRingProps = {
  radius: number;
  stroke: number;
  progress: number | undefined;
  gameStage: string;
  sportType: string;
};

const ProgressRing = ({
  radius,
  stroke,
  progress,
  gameStage,
  sportType
}: ProgressRingProps): ReactElement => {
  const PROGRESS_DURATION = ['first-half', 'second-half-start'].includes(gameStage)
    ? 90
    : ['first-extra-start', 'second-extra-start'].includes(gameStage)
    ? 30
    : 0;

  // we need subtract the stroke for both sides
  const normalizedRadius: number = radius - stroke * 2;
  // calculate circumference
  const circumference = normalizedRadius * 2 * Math.PI;
  // allows you to move the starting point of this dash-gap

  // If progress is not set, cancel out the circle
  let strokeDashoffset;

  if (
    gameStage === 'first-half-end' ||
    (gameStage === 'first-half' && !!progress && progress > 45)
  ) {
    // If half time or injury time, circle should hang at 50% filled out (out of 90mins)
    strokeDashoffset = circumference - (45 / 90) * circumference;
  } else if (
    gameStage === 'first-extra-end' ||
    (gameStage === 'first-extra-start' && !!progress && progress > 105)
  ) {
    // If half time in extra time, circle should hang at 50% filled out (out of 90mins)
    strokeDashoffset = circumference - (15 / 30) * circumference;
  } else if (
    (gameStage === 'second-half-start' && !!progress && progress > 90) ||
    (gameStage === 'second-extra-start' && !!progress && progress > 120) ||
    progress === undefined
  ) {
    strokeDashoffset = 0;
  } else {
    // In all other cases circle is dynamic
    strokeDashoffset = [
      'first-half',
      'second-half-start',
      'first-extra-start',
      'second-extra-start'
    ].includes(gameStage)
      ? circumference - (progress / PROGRESS_DURATION) * circumference
      : 0;
  }

  return (
    <svg height={radius * 2} width={radius * 2} className={`timer timer-${sportType}`}>
      <circle
        stroke="white"
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={`${circumference} ${circumference}`}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={`${circumference} ${circumference}`}
        style={{ strokeDashoffset }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
};

export default ProgressRing;
